import React, { useState, useEffect, useCallback } from "react";
import { Pagination } from "semantic-ui-react";
import { ContainerHeader, Container, Box, ContainerFilter, MainText, Input,ContainerPaginate, ButtonReset, SemanticLoader } from "./styles";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 } from "../../../../services/apis";
import Loading from "../../../Loading";
import { TableContainer, TableHead, TableRow, Paper, TableCell, TableBody, Table } from '@material-ui/core';
import { FaCheckSquare, FaWindowClose } from 'react-icons/fa'
import { smallDateFormat } from "../../../../utils/Utils";
import { Link } from "react-router-dom";
import AlunosSelector from "../../../../components/Admin/AlunosSelector";
import { Select } from 'semantic-ui-react';


const DashboardMBA = () => {
  const [absolute, setAbsolute] = useState();
  const [listMBAs, setListMBAs] = useState([]);
  const [loadingAbsolute, setLoadingAbsolute] = useState(true);
  const [loadingList, setLoadingList] = useState(true);
  const [searchAluno, setSearchAluno] = useState("");
  const [initial_date, setInitialDate] = useState("");
  const [final_date, setFinalDate] = useState("");
  const [hasDocs, setHasDocs] = useState(0);
  const [onlyTrue, setOnlyTrue] = useState(0);
  const[page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);



  const data_absolute = useCallback(async () => {
    const d = await producaov2.get("/admin/dashboard/absolute?type=mba");

    if (d.data) {
      setAbsolute(d.data);
      setLoadingAbsolute(false);
    }
  }, []);

  useEffect(() => {
    data_absolute()
  }, []);

  useEffect(() => {
    setLoadingList(true);
    let params = {
      type: "mba",
      page
    }
    if (searchAluno) {
      params.id_pessoa = searchAluno
    }
    if (initial_date && final_date) {
      params.data_inicio = initial_date
      params.data_final = final_date
    }
    if(hasDocs){
      params.hasDocs = hasDocs ? hasDocs :  0
    }
    if(onlyTrue){
      params.onlyTrue = 1
    }

    // producaov2.get(`/admin/dashboard?type=mba${searchAluno &&"&id_pessoa="+searchAluno}${searchAluno &&"&id_pessoa="+searchAluno}`)
    producaov2.get(`/admin/dashboard`, { params })
      .then(res => {
        if (res.data) {
          setListMBAs(res.data.data);
          setTotalPage(res.data.count);
          setLoadingList(false);
        }

      })
  }, [searchAluno, final_date, hasDocs, page, onlyTrue])

  if (loadingAbsolute) {
    return (
      <Loading msg="Buscando dados" />
    );
  }

  function createData(
    mba,
    nome,
    email,
    created_at,
    data_paid,
    hasDocs,
    percentage, id_pessoa
  ) {
    return { mba, nome, email,created_at, data_paid, hasDocs, percentage, id_pessoa };
  }

  const handleAlunoChange = (value) => {
    setSearchAluno(value);
  };

  const options = [
    { key: '0', value: 0, text: 'Enviou Documento' },
    { key: '1', value: 1, text: 'Sim' },
    { key: '2', value: 2, text: 'Não' },
   
  ]
  const options_testes = [
    { key: '0', value: 0, text: 'Todos' },
    { key: '1', value: 1, text: 'Sem Testes' },
   
  ]

  const valueMoney = (valor) => {
    const [main, decimal] = valor.split(".")
    const mainNumber = BigInt(main.replaceAll('_', ''))
    const decimalNumber = Number.parseFloat('0.' + decimal)
    
    const start = mainNumber.toLocaleString('pt-BR')
    const end = decimalNumber.toLocaleString('pt-BR')
    
    const result = start + end.substr(1)
    return result;
  }

  return (
    <>
      <Container>
        <h1 style={{textAlign: "left"}}>Detalhamento MBA</h1>
        <ContainerHeader>
          <Box color="#444">
            <p>N.º de MBAs</p>
            <MainText isMinimal>{absolute.total_mbas}</MainText>
          </Box>
          <Box color="#444">
            <p>N.º de Alunos</p>
            <MainText isMinimal>{absolute.total_people}</MainText>
          </Box>
          <Box color="#444">
            <p>N.º de MBA's Pagos</p>
            <MainText isMinimal>{absolute.total_mbas_paid}</MainText>
          </Box>
          <Box color="#444">
            <p>N.º MBA's Atribuidos</p>
            <MainText isMinimal>{absolute.total_mbas_atribuidos}</MainText>
          </Box>
          <Box color="#444">
            <p>Faturamento MBA</p>
            <MainText isMinimal>R$ {valueMoney(absolute.paid)}</MainText>
          </Box>
          {
            absolute.mba_unique.map(elem => {
              return (
                <Box color="#444">
                  <p>{elem.id_mba}</p>
                  <MainText isMinimal>{elem.quant}</MainText>
                </Box>
              )
            })
          }
        </ContainerHeader>
        <span>** os dados acima desconsideram as contas de testes</span>
        <h2>
          Alunos
        </h2>
        <ContainerFilter>
          <AlunosSelector handleChange={handleAlunoChange} />
          <div>
            <span>
              <label>Data inicial: </label>
              <Input
                type="date"
                value={initial_date}
                onChange={e => setInitialDate(e.target.value)}
              />
            </span>
            <span>
              <label>Data final:</label>
              <Input
                type="date"
                value={final_date}
                onChange={e => setFinalDate(e.target.value)}
              />
            </span>
            <span>
              <label>Todos os MBAs</label>
              <Select placeholder='Todos' value={onlyTrue} options={options_testes}
                onChange={(e, data) => setOnlyTrue(data.value)} />
            </span>
            <span>
              <label>Enviou Documentos</label>
              <Select placeholder='Enviou Documento?' value={hasDocs} options={options}
                onChange={(e, data) => setHasDocs(data.value)} />
            </span>
            <ButtonReset onClick={() => {
              setLoadingList(true);
              setSearchAluno("");
              setFinalDate("");
              setInitialDate("");
              setHasDocs(0);
            }}>Resetar filtros</ButtonReset>
          </div>
        </ContainerFilter>
        {
          listMBAs && !loadingList ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead >
                  <TableRow style={{ textAlign: "left", backgroundColor: "#282828" }}>
                    <TableCell align="left">MBA</TableCell>
                    <TableCell align="left">Nome</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Registro</TableCell>
                    <TableCell align="left">Pagamento</TableCell>
                    <TableCell align="center">Docs</TableCell>
                    <TableCell align="center">Progresso</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    listMBAs
                      .map(item => (createData(item.description, item.nome, item.email,item.created_at, item.data_paid, item.hasDocs, item.percentage, item.id_pessoa)))
                      .map((row, index) => (
                        <TableRow
                          hover
                          key={index}
                          component={Link}
                          to={`/admin/dashboard/aluno/${row.id_pessoa}`}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell scope="row" >
                            {row.mba}
                          </TableCell>
                          <TableCell >
                            {row.nome}
                          </TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{smallDateFormat(row.created_at)}</TableCell>
                          <TableCell align="left">{row.data_paid !== "0000-00-00 00:00:00" ? smallDateFormat(row.data_paid) : "Atribuido"}</TableCell>
                          <TableCell align="center">{row.hasDocs ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}</TableCell>
                          <TableCell align="center">{row.percentage}%</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div style={{ height: "50px", background: "none", position: "relative" }}>

              <SemanticLoader active />
            </div>
          )
        }

<ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={parseInt(totalPage/30)}
              onPageChange={(e, f) => setPage(f.activePage)}
              page={page}
            />
          </ContainerPaginate>
      </Container>
    </>
  );
};

export default DashboardMBA;
